import React from 'react';
import Tag from '../../../elements/Tag';

export default props => {
    let category = _(props.event.question_categories).find({id: props.question.category_id});
    if (category) {
        return <Tag className="pull-right" style={props.event._local.styles.button_secondary}>{category.label}</Tag>;
    }
    return null;
};
